// extracted by mini-css-extract-plugin
export default {"listContainer":"SharersList_listContainer__W7fEs","listTitle":"SharersList_listTitle__VmIMe"};